import { z } from 'zod';

// Interfaces and Enums
export enum Timeframes {
    ThreeMonths = '3M',
    SixMonths = '6M',
    OneYear = '1Y',
}

export enum EquipmentTypes {
    Van = 'VAN',
    Flatbed = 'FLATBED',
    Reefer = 'REEFER',
}

// Schemas
export const RateSchema = z.object({
    date: z.string(),               // ISO formatted date string,
    spotWithFuel: z.number(),       // Spot rate with fuel added
    spotWithoutFuel: z.number(),    // Spot rate without fuel added
    contractWithFuel: z.number(),   // Contract rate with fuel added
    contractWithoutFuel: z.number() // Contract rate without fuel added
});

export const FetchRatesResponseSchema = z.object({
    fuel: z.array(RateSchema),
    contract: z.array(RateSchema),
    spot: z.array(RateSchema)
});

export const GetRatesNationalResponseRateSchema = z.object({
    date: z.string(),
    average: z.number()
});

export const GetRatesNationalReponseSchema = z.object({
    response: z.object({
        rates: z.object({
            mile: z.array(GetRatesNationalResponseRateSchema)
        })
    })
});

// Types
export type Rate = z.infer<typeof RateSchema>;

export type GetRatesNationalResponseRate = z.infer<typeof GetRatesNationalResponseRateSchema>;
export type GetRatesNationalReponse = z.infer<typeof GetRatesNationalReponseSchema>;

export type RateInfo = { errored: boolean, rates: Rate[] };
export type RatesCache = Record<EquipmentTypes, RateInfo>;
